import { User } from '@/generated/types';
import { DEFAULT_CURRENCY } from '@/pages/YourPaymentsPage/constants';
import { CURRENCIES_ASSOCIATION, DEFAULT_LANGUAGE } from '@/constants';
import { formatPriceByLanguage } from '@/utils/money';
import { getLocale } from '@/utils/cookies';

export const mapPaymentsDetailsQueryResponseToTopPane = (
  paymentsDetailsQueryResponse: { user: User },
): string => {
  const { monthlyTotal, activeSubscriptionValue } = paymentsDetailsQueryResponse.user;
  const inCents = monthlyTotal.inCents + activeSubscriptionValue.inCents;
  const currency = activeSubscriptionValue.currency ?? DEFAULT_CURRENCY;
  const currencySymbol = CURRENCIES_ASSOCIATION[currency];
  const locale = getLocale() || DEFAULT_LANGUAGE;

  const formattedPrice = formatPriceByLanguage(inCents, locale, currencySymbol) as string;

  return formattedPrice;
};
